import { ReactElement } from 'react';
import {
  Table,
  TableBody,
  TableDataCell,
  TableHead,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  ScrollIndicator,
} from '@op/opds.opux';
import { Message, useMessage } from '@messageformat/react';
import { ReactComponent as Circle } from '../../images/green-circle.svg';
import { parseTableContent } from './utils';

const CompareTable = (): ReactElement => {
  const alignCenter = 'center';
  const tableBody = useMessage('course6.table1.rows');
  const parseTableBody = parseTableContent(tableBody);
  return (
    <ScrollIndicator>
      <div style={{ display: 'none' }} id="included">
        <Message id="course6.table1.included" />
      </div>
      <Table>
        <TableHead>
          <TableHeaderRow>
            <TableHeaderCell scope="col">
              <Message id="course6.table1.title1" />
            </TableHeaderCell>
            <TableHeaderCell align={alignCenter} scope="col">
              <Message id="course6.table1.title2" />
            </TableHeaderCell>
            <TableHeaderCell align={alignCenter} scope="col">
              <Message id="course6.table1.title3" />
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHead>
        <TableBody>
          {parseTableBody.map((value) => {
            const secondColum =
              value.secondColumn === 'circle' ? (
                <Circle role="img" aria-labelledby="included" />
              ) : (
                <>
                  <div aria-hidden="true">{value.secondColumn}</div>
                  <span className="sr-only">
                    {value.secondColumn === '-' ? (
                      <Message id="course6.table1.notIncluded" />
                    ) : (
                      value.secondColumn
                    )}
                  </span>
                </>
              );
            const thirdColumn =
              value.thirdColumn === 'circle' ? (
                <Circle role="img" aria-labelledby="included" />
              ) : (
                <>
                  <div aria-hidden="true">{value.thirdColumn}</div>
                  <span className="sr-only">
                    {value.thirdColumn === '-' ? (
                      <Message id="course6.table1.notIncluded" />
                    ) : (
                      value.thirdColumn
                    )}
                  </span>
                </>
              );
            return (
              <TableRow key={`${value.title}`}>
                <TableHeaderCell scope="row">{value.title}</TableHeaderCell>
                <TableDataCell align={alignCenter}>{secondColum}</TableDataCell>
                <TableDataCell align={alignCenter}>{thirdColumn}</TableDataCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </ScrollIndicator>
  );
};

export default CompareTable;
